import { queryOptions } from "@tanstack/react-query";
import currency from "currency.js";

import { fetchCartVoucherAssignments } from "./requests";
import { VoucherAssignment } from "./schema";

export const getTotalVoucherValue = (assignments: VoucherAssignment[]) => {
  return assignments
    .map((a) => a.amountInCents)
    .reduce(
      (a, b) => currency(a, { fromCents: true }).add(b),
      currency(0, { fromCents: true }),
    ).value;
};

export const VoucherAssignmentQueries = {
  all: (cartUuid: string) =>
    queryOptions({
      queryKey: ["voucher_assignments", { cartUuid }],
      queryFn: () => fetchCartVoucherAssignments(cartUuid),
    }),
  totalAssignmentValue: (cartUuid: string) => ({
    ...VoucherAssignmentQueries.all(cartUuid),
    select: getTotalVoucherValue,
  }),
};
